export function verificationServerOffset(serverTime: string, clientNow: number) {
  return Date.parse(serverTime) - clientNow;
}

export function verificationSecondsRemaining(
  target: string,
  serverOffset: number,
  clientNow: number,
) {
  return Math.max(
    0,
    Math.ceil((Date.parse(target) - (clientNow + serverOffset)) / 1000),
  );
}

export function formatVerificationTime(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
}
